import { useEffect, useRef, useState } from 'react'
import { createModel } from 'hox'
import { TablePaginationConfig } from 'antd/es/table/interface'
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from '@/utils/constants'
import { FranchiseePageResult, IFranchiseePageResultInsert, IFranchiseeSearchItem, intentionService } from './intentionService'
import useGlobalModel, { transPgToPagination } from '@/model/globalModel'
import { ISearchPage } from '@/types/AppTypes'
import { globalPrompt } from '@/components/message'
import { momentFormat } from '@/utils/utils'
import { useDictModel } from '../../base/dict/dictModel'
import { IMapInfo } from '@/components/YHChooseMap'

export const tabsType = {
    item: 'item',
    material: 'material',
    job: 'job',
}

export const useJoinIntention = createModel(function () {
    const { getTreeNodeName } = useDictModel(() => [])
    const { setLoadingInfo } = useGlobalModel()
    /**
     * 列表
     */
    //列表数据源
    const [dataSource, setDataSource] = useState<FranchiseePageResult[]>([])
    //查询条件
    const [searchParam, setSearchParam] = useState<IFranchiseeSearchItem>({})
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg)
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<FranchiseePageResult[]>([])
    const pgCfgRef = useRef<TablePaginationConfig>(initPgCfg)

    const [choosedId, setChoosedId] = useState<string>('')
    const [choosedFranchiseeId, setChoosedFranchiseeId] = useState<string>('')
    useEffect(() => {
        pgCfgRef.current = pgCfg
    }, [pgCfg])
    //列表查询
    const loadData = async (page: ISearchPage = pgCfgRef.current, searchValue: IFranchiseeSearchItem = searchParam) => {
        const searchParams = {
            searchItem: {
                ...searchValue,
                status: ['franchisee-status.init'],
            },
            pageSize: page?.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            orders: [{ column: 'createTime', rule: 'DESC' }],
        }
        let { retData } = await intentionService.page(searchParams)
        const { list, ...pg } = retData
        setPgCfg(transPgToPagination(pg))
        setDataSource(list)
    }
    //设置搜索value
    const updateSearchParam = (updateParam: IFranchiseeSearchItem) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({})
        setSelectedRowKeys([])
        loadData(initPgCfg, {})
    }

    const initAddFormVal = {}
    //新增表单缓存
    const [addFormVal, setAddFormVal] = useState<any>(initAddFormVal)
    //编辑表单缓存
    const [editFormVal, setEditFormVal] = useState<any>({})
    //表单新增修改
    const updateAddFormVal = (val: object | null) => {
        val ? setAddFormVal({ ...addFormVal, ...val }) : setAddFormVal(initAddFormVal)
    }
    //表单新增修改
    const updateEditFormVal = (val: object | null) => {
        val ? setEditFormVal({ ...editFormVal, ...val }) : setEditFormVal({})
    }

    const [defaultMapData, setDefaultMapData] = useState<IMapInfo | null>(null)

    //获取一条详情数据 Api
    const getOne = async (id: string) => {
        let { retData } = await intentionService.one(id)
        console.log(retData, '6666')
        let { details, ...formVal } = retData
        const { md5, fileName, address, longitude, latitude } = formVal
        let fileList: any = []
        if (md5) {
            fileList = [
                {
                    uid: md5,
                    status: 'done',
                    name: fileName,
                    response: {
                        retData: md5,
                    },
                },
            ]
        }
        formVal.fileList = fileList
        setEditFormVal({
            ...formVal,
            createTime: momentFormat(formVal.createTime as string),
        })

        setDefaultMapData({ name: address || '', addr: address || '', longitude: longitude as number, latitude: latitude as number })
    }

    //表单新增 Api
    const insertData = async (val: any) => {
        let { retData } = await intentionService.insert(val)
        globalPrompt('message', { text: '意向加盟新增成功', type: 'success' })
        return retData
    }

    //表单编辑 Api
    const editData = async (val: IFranchiseePageResultInsert & { id: string }) => {
        let data: any = {
            ...val,
        }
        let { retData } = await intentionService.update(data)
        globalPrompt('message', { text: '意向加盟编辑成功', type: 'success' })
        return retData
    }


    // Contract
    const [contractVisible, setContractVisible] = useState<boolean>(false)

    //跟进记录
    const [followUpRecordsVisible, setFollowUpRecordsVisible] = useState<boolean>(false)

    return {
        /***field***/
        editFormVal,
        addFormVal,
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        contractVisible,
        defaultMapData,
        followUpRecordsVisible,
        choosedFranchiseeId,
        /***method***/

        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        updateAddFormVal,
        updateEditFormVal,
        insertData,
        editData,
        getOne,
        setContractVisible,
        choosedId,
        setChoosedId,
        setDefaultMapData,
        setFollowUpRecordsVisible,
        setChoosedFranchiseeId,
    }
})
